import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuracion-calendario',
  templateUrl: './configuracion-calendario.component.html',
  styleUrls: ['./configuracion-calendario.component.scss']
})
export class ConfiguracionCalendarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
